<template lang="pug">
  .download-recommended-rents
    button(
      @click="downloadRecommendedRents"
      class="btn btn-primary mr-3 px-4 py-0"
    )
      | {{ $t('property_page.download') }}
</template>

<script>
  import { api } from '@/api'
  import downloadXlsx from '@/mixins/download-xlsx'


  export default {
    mixins: [downloadXlsx],

    props: {
      property: {
        type: Object,
        default() {
          return {}
        }
      },
      recommendedRent: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    
    computed: {
      downloadRecommendedRentsUrl() {
        return 'recommended_rents/download'
      },

      fileName() {
        return 'recommended_rents.xlsx'
      }
    },

    methods: {
      downloadRecommendedRents() {
        const params = { property_id: this.$route.params.id, fee_options: this.recommendedRent }
        api.post(this.downloadRecommendedRentsUrl, params, { responseType: 'arraybuffer' }).then(({ data, headers }) => {
          this.downloadXlsx(data, this.fileName, headers['content-type'])
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .download-recommended-rents {
    button {
      background-color: transparent;
      border: 1px solid rgba(0, 156, 234, 0.3);
      border-radius: 4px;
      color: #009cea;
      font-size: 14px;
      height: 40px;
      line-height: 38px;
    }
  }
</style>
